import { StyleSheet } from 'aphrodite'

import row from './row'
import list from './list'
import status from './status'

import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  row: StyleSheet.create(row),
  status: StyleSheet.create(status),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/User/partials/CommunityTable/style/index.js